import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import Layout from '../components/Layout';
import Login from '../pages/Login';
import MfaSetup from '../pages/MfaSetup';
import PendingProducts from '../pages/PendingProducts';
import Products from '../pages/Products';
import Dashboard from '../pages/Dashboard';
import ProductsJson from '../pages/ProductsJson';
import Users from '../pages/Users';
import UserDetail from '../pages/UserDetail';

export const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: <ProtectedRoute allowWithoutMfa />,
    children: [
      {
        path: '/mfa-setup',
        element: <MfaSetup />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            path: '/',
            element: <Dashboard />,
          },
          {
            path: 'pending-products',
            element: <PendingProducts />,
          },
          {
            path: 'products',
            element: <Products />,
          },
          {
            path: 'products-json',
            element: <ProductsJson />,
          },
          {
            path: 'users',
            element: <Users />,
          },
          {
            path: 'users/:userId',
            element: <UserDetail />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];
